import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as styles from './reports.module.scss';
import { Spin } from 'antd';
import talentProfileApi from '../../../../services/talentProfiles';
import file from '../../../../assets/img/fileIcon.svg';
import ViewMoreReports from '../ViewMoreReports/ViewMoreReports';
import ReportDetailModal from '../ReportDetailModal/ReportDetailModal';
import { useSelector } from 'react-redux';

const Reports = ({ staffId }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [isOpenViewMore, setIsOpenViewMore] = useState(false);
  const [selected, setSelected] = useState(null);
  const { roleId } = useSelector((state) => state.user.roleActive);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await talentProfileApi.getReports(roleId, staffId);
        if (res.status === 200) {
          setData(res.data.result);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    if (!staffId) return;
    fetchData();
  }, [roleId, staffId]);

  return (
    <>
      <Spin spinning={loading}>
        <div className={styles.wrapper}>
          <h1 className={styles.title}>Reports</h1>
          {data.map((report) => (
            <div key={report.id} className={styles.report}>
              <div className={styles.fileIcon}>
                <img src={file} alt="" width="17" height="22" />
              </div>
              <div className={styles.name} onClick={() => setSelected(report)}>
                {`${report.staff_id}_BePCB Report_FY${report.year}`}
              </div>
            </div>
          ))}
          <div className={styles.viewMore} onClick={() => setIsOpenViewMore(true)}>
            View more reports
          </div>
        </div>
      </Spin>
      <ViewMoreReports open={isOpenViewMore} setOpen={setIsOpenViewMore} staffId={staffId} setSelected={setSelected} />
      <ReportDetailModal selected={selected} setSelected={setSelected} setIsOpenViewMore={setIsOpenViewMore} />
    </>
  );
};

export default Reports;

Reports.propTypes = {
  staffId: PropTypes.string,
};
